import React, {FC} from 'react'
import {Tabs as ATabs} from 'antd'
import StylesType from '@/types/StylesType'

export interface TabsTypes {
  dataSource?: any[];
  name?: string;
  tab?: string;
  onChange?: (key: string, index: number)=>void
}

const {TabPane} = ATabs
const Tabs:FC<StylesType & TabsTypes> =props => {
  let {dataSource, name, tab, onChange} = props
  const changeActive = (valueArr: string) => {
    let [key, index] = JSON.parse(valueArr)
    onChange && onChange(key, index)
  }
  return(
    <ATabs onChange={changeActive}>
      {
        dataSource && dataSource.map((data,index)=> {
          console.log(tab, name, data)
          return <TabPane tab={tab?data[tab]:String(index)} key={JSON.stringify(name?[data[name], index]:[index,index])}>{props.children}</TabPane>
        })
      }
    </ATabs>
  )
}
export default Tabs
